module.exports = __webpack_public_path__ + "media/images/athletes/1762-719d9454b93ed20d03e70256291bdb6f.png";